// extracted by mini-css-extract-plugin
export default {"loadingContainer":"SingIn_loadingContainer__HOFbM","spinner":"SingIn_spinner__1kydc","spin":"SingIn_spin__ZnABp"};